import React from "react";
import { Overlay } from "@blueprintjs/core";
import { renderOnDocSimple } from "./utils/renderOnDoc";
import Loading from "./Loading";
export default function showAppSpinner() {
  return renderOnDocSimple( /*#__PURE__*/React.createElement(Overlay, {
    isOpen: true
  }, /*#__PURE__*/React.createElement(Loading, {
    centeredInPage: true,
    loading: true
  })));
}